﻿import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { Form } from "react-bootstrap";
import _ from "lodash";

import { Filter, FilterX, Settings, Settings2, Package, ShoppingCart, Activity, User, CalendarClock, Printer } from "lucide-react";

import { validRoles } from "@/services/Utils";
import { changeOption } from "@/api/Dashboard/dashboard";
import { UPDATE_DASHBOARD } from "@/redux/types/auth.types";

import SqlAccessButton from "./SqlAccessButton";
import classes from "./fast-access.module.scss";

const FastAccess = ({ showFilter, setShowFilter }) => {
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isManager = validRoles(userRoles, ["administrador", "administrador_campo", "gerente_agricola"]);
	const isUser = validRoles(userRoles, ["administrador_campo"]);

	const { mutate: saveChangeOption } = useMutation(changeOption, {});
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const refButton = useRef(null);
	const refDiv = useRef(null);

	const [active, setActive] = useState(false);

	const { dashboard } = useSelector((state) => state.auth);

	const handleClickOutside = (event) => {
		if (refButton.current && !refButton.current.contains(event.target) && refDiv.current && !refDiv.current.contains(event.target)) {
			setActive(false);
		}
	};

	const handleSelectOption = (index) => {
		let newDashboard = [..._.orderBy(dashboard, ["name"], ["asc"])];
		newDashboard[index].active = !newDashboard[index].active;
		newDashboard[index].show_column = "";

		const countFirst = dashboard.filter((dash) => dash.show_column === "first" && dash.active);
		const countSecond = dashboard.filter((dash) => dash.show_column === "second" && dash.active);

		if (countFirst.length > countSecond.length) {
			newDashboard[index].show_column = "second";
			newDashboard[index].show_order = countSecond.length + 1;
		} else {
			newDashboard[index].show_column = "first";
			newDashboard[index].show_order = countFirst.length + 1;
		}

		dispatch({
			type: UPDATE_DASHBOARD,
			payload: {
				dashboard: newDashboard,
			},
		});

		saveChangeOption({
			...newDashboard[index],
			value: newDashboard[index].active,
		});
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
	}, []);

	return (
		<div className={classes.fast_access}>
			<div className={`${classes.div_setting} ${classes.filter}`}>
				<div className={`${classes.setting} ${showFilter && classes.active}`}>
					{showFilter ? (
						<FilterX className={classes.icon} onClick={() => setShowFilter(!showFilter)} />
					) : (
						<Filter className={classes.icon} onClick={() => setShowFilter(!showFilter)} />
					)}
				</div>
			</div>

			<div className={classes.div_main_access}>
				<div className={classes.div_access}>
					<div className={classes.access_card} onClick={() => navigate("/ordenes_aplicacion")}>
						<CalendarClock size={18} style={{ marginRight: "6px" }} />
						<span className={classes.access_card_span}>Ord. Aplicación</span>
					</div>
				</div>
				<div className={classes.div_access}>
					<div className={classes.access_card} onClick={() => navigate("/guias_despacho")}>
						<ShoppingCart size={18} style={{ marginRight: "6px" }} />
						<span className={classes.access_card_span}>Compras</span>
					</div>
				</div>
				<div className={classes.div_access}>
					<div className={classes.access_card} onClick={() => navigate("/inventario")}>
						<Package size={18} style={{ marginRight: "6px" }} />
						<span className={classes.access_card_span}>Inventario</span>
					</div>
				</div>
				<div className={classes.div_access}>
					<div className={classes.access_card} onClick={() => navigate("/historiales/usos")}>
						<Activity size={18} style={{ marginRight: "6px" }} />
						<span className={classes.access_card_span}>Historial de Uso</span>
					</div>
				</div>
				<div className={classes.div_access}>
					<div className={classes.access_card} onClick={() => navigate("/perfil")}>
						<User size={18} style={{ marginRight: "6px" }} />
						<span className={classes.access_card_span}>Perfil</span>
					</div>
				</div>
				<SqlAccessButton />
			</div>

			<div className={classes.div_setting}>
				<div className={`${classes.setting} ${classes.hide_on_mobile}`} style={{ marginRight: "5px", display: "none" }}>
					<Printer
						className={classes.icon}
						onClick={() => {
							setTimeout(() => globalThis.print(), 100);
						}}
					/>
				</div>

				<div className={`${classes.setting} ${active && classes.active}`}>
					{active ? (
						<Settings2 className={classes.icon} onClick={() => setActive(!active)} ref={refButton} />
					) : (
						<Settings className={classes.icon} onClick={() => setActive(!active)} ref={refButton} />
					)}

					{active && (
						<div className={classes.settings_options} ref={refDiv}>
							<div className={classes.settings_title}>Resumen Personalizado</div>
							<hr className={classes.settings_hr} />
							<table className={classes.settings_table}>
								<tbody>
									{_.orderBy(dashboard, ["name"], ["asc"]).map((option, i) => {
										if (option.is_admin && !isManager) return null;
										if (Number(option.id) === 10 && isUser && !isManager) return null;

										return (
											<tr key={i}>
												<td className={classes.settings_table_text}>{option.name}</td>
												<td className={classes.settings_table_check}>
													<Form.Check
														type="switch"
														id={`switch${i}`}
														checked={!!option.active}
														onChange={() => handleSelectOption(i)}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default FastAccess;
